import { Chip, Fab } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { BaseEdge, EdgeLabelRenderer, getSmoothStepPath, getStraightPath, Position } from "@xyflow/react";
import { useContext, useState } from "react";
import { CalculationVisualizerContext } from "../../../Context/CalculationVisualizerContextProvider";
import { v4 as uuid } from 'uuid';

function parseEdgeIds(input) {
  // Match full UUIDs, 'start', or 'end'
  const pattern = /([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|start|end)/gi;
  const matches = input.match(pattern) || [];
  
  // Extract identifier (anything that's not a UUID, 'start', or 'end')
  const identifier = input
    .replace(pattern, '')
    .replace(/-/g, '')
    .trim() || null;
  
  return {
    prev: matches[0]?.toLowerCase() || null,
    next: matches[1]?.toLowerCase() || null,
    identifier: identifier
  };
}

export default function CustomEdge (data) {
  const { isPromoFlow, includesPricing, setNewNodeData, setIsNewNodeModalOpen } = useContext(CalculationVisualizerContext);
  const edgeIds = parseEdgeIds(data.id);

  const [path, labelX, labelY] = getSmoothStepPath({
    sourceX: data.sourceX,
    sourceY: data.sourceY,
    sourcePosition: Position.Right,
    targetX: data.targetX,
    targetY: data.targetY,
    targetPosition: Position.Left,
    borderRadius: 10,
  });

  const style = {
    ...data.style
  };

  if (includesPricing && !isPromoFlow && !!data?.data?.standardPricing?.isNextPath) {
    style.stroke = '#000000';
    style.strokeWidth = '4';
  } else if (includesPricing && isPromoFlow && !!data?.data?.promotionPricing?.isNextPath) {
    style.stroke = '#000000';
    style.strokeWidth = '4';
  }
  
  const addNewNode = () => {
    setNewNodeData({
      id: uuid(),
      ...edgeIds,
    })

    setIsNewNodeModalOpen(true);
    return;
  }
  
  return (
    <>
      <BaseEdge 
        id={data.id} 
        path={path} 
        style={style} 
      />
      {!includesPricing && (
        <EdgeLabelRenderer>
          <Fab 
            size="small" 
            onClick={() => addNewNode()} 
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              pointerEvents: 'all',
              boxShadow: "none",
            }}
          >
            <Add fontSize="medium"/>
          </Fab>
          
        </EdgeLabelRenderer>
      )}
      {data.label === 'default' && (
        <EdgeLabelRenderer>
          <Chip
            size="small"
            label={"default"}
            variant="outlined"
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              top: includesPricing ? "0px" : "40px",
              backgroundColor: "#FFFFFF"
            }}
          />  
        </EdgeLabelRenderer>
      )}
    </>
  )
}